import { Card } from '@digital-pulse/react';
import Image from 'next/image';
import { FC, ReactNode } from 'react';
import FolderIcon from '@/assets/icons/Folder.svg';

interface Props {
  title: string;
  description: string;
  variant?: 'one-column' | 'two-column';
}

const InfoCard: FC<Props> = ({
  title,
  description,
  variant,
}): ReactNode => {
  const cardVariant = variant || 'two-column';

  return (
    <Card
      renderHeading={title ? <h2>{title}</h2> : undefined}
      renderBody={description ? <p>{description}</p> : undefined}
      renderMedia={<Image src={FolderIcon} alt="" aria-hidden="true" />}
      mediaAlignment="reverse"
      border="outlined"
      variant={cardVariant}
    />
  );
}

export default InfoCard;
